export type ThemePreference = 'light' | 'dark' | 'system';

export const normalizeThemePreference = (theme?: string): ThemePreference => {
  if (theme === 'dark' || theme === 'light') {
    return theme;
  }
  return 'system';
};

export const detectSystemTheme = (): 'light' | 'dark' => {
  if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }
  return 'light';
};
